import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { Article, ArticleService } from '../shared';

import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';

import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  moduleId: module.id,
  selector: 'bp-article',
  templateUrl: './article.component.html',
})

export class ArticleComponent implements OnDestroy, OnInit {
  @Input() article: Article;
  editArticle: Article = <Article>{};
  similarArticles: Article[];
  private dbResetSubscription: Subscription;
  private id: any;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  fullMainHtml: any;
  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private articleService: ArticleService,
    private toastService: ToastService,
    private sanitizer: DomSanitizer) { }


  ngOnInit() {

    // this.dbResetSubscription = this.articleService.onDbReset
    //   .subscribe(() => this.getArticle());

    this.route
      .params
      .map(params => params)
      .do(params => this.id = +params['id'])
      .subscribe(params => {
        // console.log('========> route parmas', this.route.snapshot.url[0].path);
        this.getArticle();

      });

    this.galleryOptions = [
      { arrowPrevIcon: "fa fa-chevron-left", arrowNextIcon: "fa fa-chevron-right" },
      {
        width: '600px',
        height: '400px',
        thumbnails: false,
        imageAnimation: NgxGalleryAnimation.Slide
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '600px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: false
      }
    ];


  }

  ngOnDestroy() {
    //this.dbResetSubscription.unsubscribe();
  }

  cancel(showToast = true) {
    this.article = this.entityService.clone(this.article);
    if (showToast) {
      this.toastService.activate(`Cancelled changes to ${this.article.title}`);
    }
  }



  isAddMode() {
    return isNaN(this.id);
  }


  private getArticle() {
    //this.modalService.activate();
    //this.toastService.activate('Otvaram clanak');
    if (this.id === 0) { return; }; //TODO: nece da radi zato sto ima id ===0
    if (this.isAddMode()) {
      this.article = <Article>{

      };
      this.editArticle = this.entityService.clone(this.article);
      return;
    }
    this.articleService.getArticle(this.id)
      .subscribe(article => {
        this.fullMainHtml = this.sanitizer.bypassSecurityTrustHtml(article.mainText);
        this.setEditArticle(article);
        this.getSimilarArticles();
        this.galleryImages = [];
        let imagesCount = article.images.length;
        for (let i = 0; i < imagesCount; i++) {
          let img = article.images[i];
          this.galleryImages.push(
            {
              small: img.imageUrl,
              medium: img.imageUrl,
              big: img.imageUrl,
            }
          );
        }
      });
  }

  private getSimilarArticles() {
    this.articleService.getSimilarArticles(this.article.contentTypeId)
      .subscribe((articles: Article[]) => {
        this.similarArticles = articles;
      })
  }

  private gotoNews() {
    this.router.navigate(['/news']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  private isDirty() {
    return this.entityService.propertiesDiffer(this.article, this.editArticle);
  }

  private setEditArticle(article: Article) {
    //console.log('=======> article', article);
    if (article) {
      this.article = article;
      this.editArticle = this.entityService.clone(this.article);
    } else {
      this.gotoNews();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/news/article/article.component.ts